module.exports = __webpack_public_path__ + "img/Foto_Lynn_2.77dd07b2.jpg";